import { createSlice } from "@reduxjs/toolkit";

// Define the initial state for the profileDataSlice slice
const initialState = {
    "@odata.context": null,
    "businessPhones": [],
    "displayName": null,
    "givenName": null,
    "jobTitle": null,
    "mail": null,
    "mobilePhone": null,
    "officeLocation": null,
    "preferredLanguage": null,
    "surname": null,
    "userPrincipalName": null,
    "id": null
};

// Create the profileDataSlice slice using createSlice
const profileDataSlice = createSlice({
    name: "profileData", // Slice name
    initialState, // Initial state
    reducers: {
        // Reducer functions to update the state
        updateProfileData(state, action) {
            state["@odata.context"] = action.payload["@odata.context"] || state["@odata.context"]
            state.businessPhones = action.payload.businessPhones || state.businessPhones
            state.displayName = action.payload.displayName || state.displayName
            state.givenName = action.payload.givenName || state.givenName
            state.id = action.payload.id || state.id
            state.jobTitle = action.payload.jobTitle || state.jobTitle
            state.mail = action.payload.mail || state.mail
            state.mobilePhone = action.payload.mobilePhone || state.mobilePhone
            state.officeLocation = action.payload.officeLocation || state.officeLocation
            state.preferredLanguage = action.payload.preferredLanguage || state.preferredLanguage
            state.surname = action.payload.surname || state.surname
            state.userPrincipalName = action.payload.userPrincipalName || state.userPrincipalName
        },

        resetProfileData(state, action) {
            state["@odata.context"] = initialState["@odata.context"]
            state.businessPhones = initialState.businessPhones
            state.displayName = initialState.displayName
            state.givenName = initialState.givenName
            state.id = initialState.id
            state.jobTitle = initialState.jobTitle
            state.mail = initialState.mail
            state.mobilePhone = initialState.mobilePhone
            state.officeLocation = initialState.officeLocation
            state.preferredLanguage = initialState.preferredLanguage
            state.surname = initialState.surname
            state.userPrincipalName = initialState.userPrincipalName
        },
    },
});

// Export the reducer functions as actions
export const {
    updateProfileData,
    resetProfileData
} = profileDataSlice.actions;
// Export the reducer function itself
export default profileDataSlice.reducer;
